export const PersonalityTypes = {
    AGVANCE_STANDARD: 3,
    DISCONNECTED: 2,
    HELENA_CORPORATE: 1,
};
